import React from 'react';

import RadioButton from 'components/RadioButton';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { VehicleSorterTypes } from 'models/auto/vehicleResults';

import { Container, OptionName } from './styles';

interface Props {
  value: VehicleSorterTypes;
  onChange: (value: VehicleSorterTypes) => void;
}

const Order = ({ value, onChange }: Props) => {
  const { t } = useStoreTranslation();

  return (
    <section>
      <Container>
        <RadioButton
          value={VehicleSorterTypes.Recommended}
          optionValue={value}
          handleChangeValue={(value) => onChange(value)}
        />
        <OptionName onClick={() => onChange(VehicleSorterTypes.Recommended)}>
          {t('autosFilter.sorter.recommended')}
        </OptionName>
      </Container>
      <Container>
        <RadioButton
          value={VehicleSorterTypes.PriceDesc}
          optionValue={value}
          handleChangeValue={(value) => onChange(value)}
        />
        <OptionName onClick={() => onChange(VehicleSorterTypes.PriceDesc)}>
          {t('autosFilter.sorter.highPrice')}
        </OptionName>
      </Container>
      <Container>
        <RadioButton
          value={VehicleSorterTypes.Price}
          optionValue={value}
          handleChangeValue={(value) => onChange(value)}
        />
        <OptionName onClick={() => onChange(VehicleSorterTypes.Price)}>{t('autosFilter.sorter.lowPrice')}</OptionName>
      </Container>
    </section>
  );
};

export default Order;
